/**
 * L1J Web Client - MenuButton Component (Lineage Classic Style)
 *
 * 우상단에 표시되는 메뉴 토글 버튼 (>>).
 * 클릭 시 외부 콜백이 호출되며, GameScene은 이를 기존 menuPanel 토글에 연결한다.
 *
 * 카메라 스크롤과 무관하게 화면에 고정.
 */

import Phaser from 'phaser';

export class MenuButton extends Phaser.GameObjects.Container {
  private bg!: Phaser.GameObjects.Rectangle;
  private arrowText!: Phaser.GameObjects.Text;
  private isOpen: boolean = false;

  public onClick: (() => void) | null = null;

  constructor(scene: Phaser.Scene, x: number, y: number) {
    super(scene, x, y);
    scene.add.existing(this);

    this.setScrollFactor(0);
    this.setDepth(100);

    this.createUI();
  }

  private createUI(): void {
    const size = 36;

    this.bg = this.scene.add.rectangle(0, 0, size, size, 0x1a1a2e, 0.9);
    this.bg.setStrokeStyle(2, 0xffd700);
    // Phaser 버그 아님/주의: 컨테이너의 setScrollFactor(0)은 자식에 상속되지 않는다.
    // 자식(bg)에도 직접 걸어줘야 카메라가 스크롤된 상태에서도 클릭 히트테스트가 맞는다.
    this.bg.setInteractive({ useHandCursor: true });
    this.bg.setScrollFactor(0);
    this.add(this.bg);

    this.arrowText = this.scene.add.text(0, 0, '≡', {
      fontSize: '22px',
      fontFamily: 'Arial, sans-serif',
      color: '#ffd700',
      fontStyle: 'bold'
    });
    this.arrowText.setOrigin(0.5);
    this.add(this.arrowText);

    this.bg.on('pointerover', () => {
      this.bg.setFillStyle(0x3a3a5e, 1);
    });
    this.bg.on('pointerout', () => {
      this.bg.setFillStyle(0x1a1a2e, 0.9);
    });
    this.bg.on('pointerdown', () => this.activate());
  }

  private activate(): void {
    // 깜빡임 효과
    this.bg.setFillStyle(0xffd700, 0.4);
    this.scene.time.delayedCall(120, () => {
      this.bg.setFillStyle(0x1a1a2e, 0.9);
    });
    if (this.onClick) this.onClick();
  }

  public setOpen(open: boolean): void {
    this.isOpen = open;
    // 메뉴 상태에 따라 아이콘 변경 (≡ ↔ ×)
    this.arrowText.setText(open ? '×' : '≡');
  }
}
